<app-header></app-header>

<div class="logo-f">
    <img src="assets/images/logo/Full_logo.svg" alt="" class="img-fluid">
</div>
<section class="content tab-section d-flex flex-column">
    <div class="content-block flex-grow-1">
        <div class="row">
            <div class="col-lg-7 ps-lg-0">
                <div class="white-b">
                    <div class="d-box">
                        <img src="assets/images/package/order_purchased.svg" class="img-fluid" alt="">
                    </div>
                    <div class="text-center header-tit tit">Thank you for your purchase</div>
                    <div class="text-center desc mt-2">Congratulations on your recent purchase! Thank you for choosing
                        our portal. We're thrilled to
                        have you onboard and are excited to see you dive into your selected course.</div>
                    <div class="d-box mt-3">
                        <button mat-raised-button color="primary" class="m-2 primary-btn btn no-sh-btn btn-margin" *ngIf="!isOffferData"
                            type="submit" (click)="goToMyCourse()"> Go to {{userType == 'company' ? "Courses":"My Courses"}}
                       </button>
                       <button mat-raised-button color="primary" class="m-2 primary-btn btn no-sh-btn btn-margin" *ngIf="isOffferData"
                       type="submit" (click)="goToUserManagement()"> Go to Dashboard
                  </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 mt-4 mt-lg-0 pe-lg-0">
                <div class="white-b">
                    <div class="header-tit">Receipt</div>
                    <div class="mt-3 mb-3 r-box d-flex ">
                        <div class="r-img me-3" [appBackgroundImg]="orderData.i_img" [iType]="'thank_you'"></div>
                        <div>
                            <div class="heading-3">Order ID: {{orderData.or_id }}</div>
                            <div class="mt-1 dt">{{orderData.dt }}</div>
                        </div>
                    </div>
                    <div class="item-b pt-1">
                        <div class="item-l item-m">Item Name:</div>
                        <div class="item-r item-m">{{orderData.it }} </div>
                    </div>
                    <div class="item-b">
                        <div class="item-l item-m">Quantity:</div>
                        <div class="item-r item-m">{{orderData.qt }}</div>
                    </div>
                    <div class="item-b">
                        <div class="item-l item-m">Unit Price:</div>
                        <div class="item-r item-m">€{{orderData.u_p }}</div>
                    </div>
                    <div class="item-b">
                        <div class="item-l item-m">Tax({{orderData.pr}}%):</div>
                        <div class="item-r item-m">€{{orderData.tax}}</div>
                    </div>
                    <div class="item-b">
                        <div class="item-l item-m">Amount:</div>
                        <div class="item-r item-m">€{{orderData.amt}}</div>
                    </div>
                    <div class="b-box"></div>
                    <button mat-raised-button color="warn" class="auth-form-btn  success-btn mt-3 " type="submit"
                        (click)="onDownloadInvoice()">  Download Invoice</button>
                </div>
            </div>
        </div>
    </div>
</section>